import React, { useEffect } from 'react'
import { useRaportForm } from '../../context/RaportFormContext'
import Options from './stages/Options'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { faSlidersSolid } from '@/lib/fa'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

// Kolejnosc = VehicleCardReadingAndCalibrationDeadlineSortingField
const SORTING_OPTIONS = [
  'printout.readingCalibrationSortRegistrationNumber',
  'printout.readingCalibrationSortLastReading',
  'printout.readingCalibrationSortNextReading',
  'printout.readingCalibrationSortCalibrationDate',
  'printout.readingCalibrationSortNextCalibrationDate',
]

const DEFAULT_READING_CALIBRATION_SORTING = 2

const ReadingAndCalibrationDeadline = () => {
  const { data, setData } = useRaportForm()
  const { t } = useLocalize()

  useEffect(() => {
    setData((prev: any) => ({
      sortingField: DEFAULT_READING_CALIBRATION_SORTING,
      separateFiles: false,
      separateCsvFiles: false,
      issuerSignature: false,
      driverSignature: false,
      ...prev,
    }))
  }, [])

  const options = SORTING_OPTIONS.map((label, index) => ({
    value: String(index),
    label: t(label),
  }))

  return (
    <div className="tw-flex-1 tw-space-y-4 tw-overflow-auto tw-p-4 tw-pr-8">
      <div className="tw-flex tw-items-start">
        <StageHeader title={t('printout.data')} textSize="sm" icon={faSlidersSolid} />
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
          <FieldsetSelect
            label={t('printout.sort-by')}
            value={String(data?.sortingField ?? DEFAULT_READING_CALIBRATION_SORTING)}
            name="sortingField"
            onChange={(e) => {
              setData({
                ...data,
                sortingField: Number(e.target.value),
              })
            }}
            searchEnabled={false}
            options={options}
          />
        </div>
      </div>
      <DividerHorizontal />
      <Options
        setData={setData}
        data={data}
        vehicleActivity={false}
        separateFilesOnly={false}
        separateCsvFiles
      />
    </div>
  )
}

export default ReadingAndCalibrationDeadline
